import React, { useState, useEffect } from 'react';
import { Caption, H3, H4, PageSection } from 'common/styles/page';
import DashboardCard from './DashboardCard';
import DoughnutGauge from './DoughnutGauge';

import { useApiPortalV1AssessmentsResultsListQuery } from 'areas/assessment-schedule/api';
import { useNavigate } from 'react-router';

import { AggregateType } from 'common/constants/AggregateType';
interface DashboardGreatestDeficitsProps {
  assessment_period_id: number;
}

const DashboardGreatestOpportunities = ({
  assessment_period_id,
}: DashboardGreatestDeficitsProps) => {
  const navigate = useNavigate();
  interface Strength {
    label: string;
    sublabel: string;
    value: number;
    summary?: string;
  }

  const [deficits, setDeficits] = useState<Strength[]>([]);
  const { data } = useApiPortalV1AssessmentsResultsListQuery({
    aggregateType: AggregateType.GREATEST_OPPORTUNITIES,
    assessmentPeriodId: assessment_period_id,
  });

  useEffect(() => {
    if (data && data.length > 0) {
      const deficitsData = data[0]?.result;
      const deficits = deficitsData?.map(
        (item: {
          category_name: string;
          option_name: string;
          pillar_name: string;
          ai_summary: string;
          overall_score: number | string | null | undefined; // AI returns sometimes returns a string
        }) => {
          const score =
            item?.overall_score !== undefined && item?.overall_score !== null
              ? parseFloat(item.overall_score as string)
              : 0;
          return {
            label: `${item.category_name}: ${item.option_name}`,
            sublabel: `${item.pillar_name}`,
            value: !isNaN(score) ? parseFloat(score.toFixed(1)) : 0,
            summary: item?.ai_summary,
          };
        }
      );

      setDeficits(deficits);
    }
  }, [data]);

  return (
    <DashboardCard
      title="Greatest Opportunities"
      onClick={() => navigate('/app/analytics/?tab=3&option=def')}
    >
      <PageSection display="flex" flexDirection="column">
        {deficits.length === 0 && (
          <p>
            No group in this assessment period had enough respondents to report on without
            identifying individuals.
          </p>
        )}
        {deficits.map((deficit, index) => (
          <PageSection
            gap="15px"
            padbottom="10px"
            display="flex"
            alignItems="flex-start"
            key={index}
          >
            <DoughnutGauge
              max={10}
              complete={deficit.value}
              precision={1}
              size="small"
              colorize={true}
            />
            <PageSection gap="15px" flex="1">
              <H3>{deficit.sublabel}</H3>
              <H4>{deficit.label}</H4>
              {deficit.summary && <Caption>{deficit.summary}</Caption>}
            </PageSection>
          </PageSection>
        ))}
      </PageSection>
    </DashboardCard>
  );
};

export default DashboardGreatestOpportunities;

